import { RSAA } from 'redux-api-middleware';
import * as YAA from '../actions/yourAccountActions';

export const 
getYourAccountData = url => ({ [RSAA]: {
    endpoint: url,
    method: 'GET',
    types: [
        YAA.YOUR_ACCOUNT_REQUEST,
        YAA.SUCCESS_YOUR_ACCOUNT_REQUEST,
        YAA.FAILURE_YOUR_ACCOUNT_REQUEST
    ]
}}),

updateContactInfo = (userId, payload) => ({ [RSAA]: {
    endpoint: `/user/updateContactInfo/${userId}`,
    method: 'PATCH',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
    types: [
        YAA.UPDATE_CONTACT_INFO_REQUEST,
        YAA.SUCCESS_UPDATE_CONTACT_INFO_REQUEST,
        YAA.FAILURE_UPDATE_CONTACT_INFO_REQUEST
    ]
}}),

updateSecurityQuestionAnswers = (userId, payload) => ({ [RSAA]: {
    endpoint: `/user/updateSecurityQuestionAnswers/${userId}`,
    method: 'PATCH',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
    types: [
        YAA.UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST,
        YAA.SUCCESS_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST,
        YAA.FAILURE_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST
    ]
}}),

updatePassword = payload => ({ [RSAA]: {
    endpoint: '/user/updatePassword',
    // method: 'PATCH',
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
    types: [
        YAA.UPDATE_PASSWORD_REQUEST,
        YAA.SUCCESS_UPDATE_PASSWORD_REQUEST,
        YAA.FAILURE_UPDATE_PASSWORD_REQUEST
    ]
}}),

getEmailPreferences = displayRole => ({ [RSAA]: {
    endpoint: `/email/optOut/${displayRole}`,
    method: 'GET',
    types: [
        YAA.GET_EMAIL_PREFERENCES,
        YAA.GET_EMAIL_PREFERENCES_SUCCESS,
        YAA.GET_EMAIL_PREFERENCES_FAILURE
    ]
}}),

saveEmailPreferences = preferences => ({ [RSAA]: {
    endpoint: `/email/optOut`,
    method: 'POST',
    body: JSON.stringify(preferences),
    headers: { 'Content-Type': 'application/json' },
    types: [
        YAA.SAVE_EMAIL_PREFERENCES,
        YAA.SAVE_EMAIL_PREFERENCES_SUCCESS,
        YAA.SAVE_EMAIL_PREFERENCES_FAILURE
    ]
}}),

resetEditContactInfoFlags = () => ({ type: YAA.RESET_EDIT_CONTACT_INFO_FLAGS }),
resetChangeSecurityQuestionsAnswerFlags = () => ({ type: YAA.RESET_CHANGE_SECURITY_QUESTION_ANSWERS_FLAGS }),
resetChangePasswordFlags = () => ({ type: YAA.RESET_CHANGE_PASSWORD_FLAGS }),

// Additional: 05/25/2018 //
changeView = (v, newState)  => ({
    type: YAA.CHANGE_YOUR_ACCOUNT_VIEW,
    payload: v,
    newState: newState
}),

resetView = () => ({ type: YAA.RESET_YOUR_ACCOUNT_VIEW }),

updateDataEntry = e => {
    const { name, value } = e.target;
    return { 
        type:  YAA.UPDATE_DATA_ENTRY, 
        payload: { name, value }
    };
},

updateEmailCheckbox = e => {
    const { name, checked } = e.target;
    return { 
        type: YAA.UPDATE_EMAIL_CHECKBOX, 
        payload: { name, checked }
    };
},

toggleCanUpdateContactInfo = () => ({ type: YAA.TOGGLE_CAN_UPDATE_CONTACT_INFO }),
resetDataRequest = () => ({ type: YAA.RESET_YOUR_ACCOUNT_DATA_REQUEST }),
resetContactInfoRequest = () => ({ type: YAA.RESET_YOUR_ACCOUNT_CONTACT_INFO_REQUEST }),
resetSecurityQuestionsRequest = () => ({ type: YAA.RESET_YOUR_ACCOUNT_SECURITY_QUESTIONS_REQUEST }),
toggleShowView = forceShow => ({ type: YAA.TOGGLE_YOUR_ACCOUNT_SHOW_VIEW, payload: forceShow || null }),
resetPasswordUpdateRequest = () => ({ type: YAA.RESET_YOUR_ACCOUNT_PASSWORD_UPDATE_REQUEST }),
resetEmailPreferencesUpdate = () => ({ type: YAA.RESET_EMAIL_PREFERENCES_UPDATE });
